import script from "./Detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./Detail.vue?vue&type=script&lang=ts&setup=true"

import "./Detail.vue?vue&type=style&index=0&id=37f4a47b&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f4a47b"]])

export default __exports__